import { Space, Switch, Tooltip } from 'antd';
import { FC } from 'react';
import { ReactComponent as BackArrowIcon } from '../../../../../../../assets/svgs/back-arrow-icon.svg';

import './Settings.less';

interface SettingsProps {
  isGridVisible: boolean;
  isRendered: boolean;
  onToggleGrid: () => void;
  onToggleRenderType: () => void;
  onClose: () => void;
}

const Settings: FC<SettingsProps> = ({
  isGridVisible,
  isRendered,
  onToggleGrid,
  onToggleRenderType,
  onClose,
}) => {
  return (
    <section className="settings-side-panel-section">
      <div className="side-panel-header">
        <div className="side-panel-header__section-left">
          <Space direction="horizontal" size="middle">
            <Tooltip title="Back">
              <BackArrowIcon
                style={{
                  paddingTop: '2px',
                  cursor: 'pointer',
                  marginTop: '6px',
                }}
                onClick={onClose}
              />
            </Tooltip>
            <h1>Settings</h1>
          </Space>
        </div>
      </div>
      <div className="settings-wrapper">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div className="setting-item-wrapper">
            <div className="setting-item-name">Display rendered images</div>
            <Switch checked={isRendered} onChange={onToggleRenderType} />
          </div>

          <div className="setting-item-wrapper">
            <div className="setting-item-name">Display grid</div>
            <Switch checked={isGridVisible} onChange={onToggleGrid} />
          </div>
        </Space>
      </div>
    </section>
  );
};

export default Settings;
